module.exports = __webpack_public_path__ + "img/bg-header.ee5b10ce.png";